import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import classnames from 'classnames';
import { Drawer, Icon, Wrapper } from '@mademine/components';
import { I18n, Currency } from '@mademine/utils';
import { IncrementType } from '../../../pages/index';
import { ReactComponent as IconClose } from '../../../assets/icon-arrow-bold-close.svg';
import { ReactComponent as SubscriptIcon } from '../../../assets/icon-subscript.svg';
import { useData } from '../../../hooks/useData';
import styles from './style.module.less';
var IncrementDrawer = function (_a) {
    var shop = _a.shop, type = _a.type, image = _a.image, canvasDataFromRoot = _a.canvasDataFromRoot, selectedOptionFromRoot = _a.selectedOptionFromRoot, productIncrement = _a.productIncrement, handleIncrement = _a.handleIncrement, setIncrementType = _a.setIncrementType, setAddedPrice = _a.setAddedPrice, setZuploaderVisible = _a.setZuploaderVisible, onClose = _a.onClose;
    var _b = useData(), peopleNumber = _b.peopleNumber, backSideNewImage = _b.backSideNewImage, hasBackSideUpload = _b.hasBackSideUpload, setBackSideNewImage = _b.setBackSideNewImage, setCurrentSide = _b.setCurrentSide;
    var buttonType = useMemo(function () {
        var normalButton = [
            {
                text: I18n.format('modules.mini.me.one.side.only.print') || '',
                funcType: IncrementType.SameSide
            },
            {
                text: I18n.format('modules.mini.me.double.side.print') || '',
                price: productIncrement.normal.price,
                funcType: IncrementType.DoubleSide
            }
        ];
        var type = {
            normal: normalButton,
            hood: peopleNumber === 2
                ? normalButton
                : [
                    {
                        text: I18n.format('modules.mini.me.one.side.only.print') || '',
                        funcType: IncrementType.SameSide
                    },
                    {
                        text: I18n.format('modules.mini.me.add.photo.back.side') || '',
                        price: productIncrement.hood.price,
                        funcType: IncrementType.NewImageSide
                    }
                ]
        };
        return type;
    }, []);
    var _c = useState(0), buttonSelected = _c[0], setButtonSelected = _c[1];
    var handleConfirm = function () {
        var _a, _b;
        var funcType = buttonType[type][buttonSelected].funcType;
        if (funcType === IncrementType.NewImageSide) {
            setAddedPrice((_a = buttonType[type][buttonSelected].price) !== null && _a !== void 0 ? _a : 0);
            setIncrementType(funcType);
            setZuploaderVisible(true);
            setCurrentSide(2);
        }
        else if (funcType === IncrementType.DoubleSide) {
            setAddedPrice((_b = buttonType[type][buttonSelected].price) !== null && _b !== void 0 ? _b : 0);
            setIncrementType(funcType);
        }
        else {
            setIncrementType(funcType);
        }
        if (!hasBackSideUpload) {
            handleIncrement(funcType);
        }
    };
    function sidePreviewDom(type) {
        if (type.funcType === IncrementType.SameSide) {
            return (_jsx(_Fragment, { children: _jsx("div", { className: "_sz-flex _sz-h-[140px] _sz-w-full _sz-items-center _sz-justify-center", children: _jsx("img", { src: image, className: "_sz-inline-block _sz-max-h-full _sz-max-w-full" }) }) }));
        }
        else if (type.funcType === IncrementType.DoubleSide) {
            return (_jsxs("div", { className: "_sz-flex _sz-h-[140px] _sz-w-full _sz-items-center _sz-justify-center", children: [_jsx("img", { src: image, className: "_sz-inline-block  _sz-max-h-full _sz-max-w-[50%]" }), _jsx("img", { src: image, className: "_sz-inline-block _sz-max-h-full _sz-max-w-[50%]" })] }));
        }
        else {
            return (_jsxs("div", { className: "_sz-flex _sz-h-[140px] _sz-w-full _sz-items-center _sz-justify-center", children: [_jsx("img", { src: image, className: "_sz-inline-block  _sz-max-h-full _sz-max-w-[50%]" }), _jsx("img", { src: backSideNewImage, className: "_sz-inline-block  _sz-max-h-full _sz-max-w-[50%]" })] }));
        }
    }
    return (_jsx(Wrapper, { position: "absolute", className: "_sz-z-[12]", children: _jsx(Drawer, { onClose: onClose, mask: true, children: _jsxs("div", { className: "_sz-rounded-t-2xl _sz-bg-white _sz-p-5 _sz-pb-9 sm:_sz-pb-5", children: [_jsx("div", { className: "_sz-absolute _sz-top-0 _sz-left-0 _sz-m-3 _sz-cursor-pointer _sz-p-2", onClick: onClose, children: _jsx(Icon, { color: "#191919", size: 24, children: _jsx(IconClose, {}) }) }), _jsx("h1", { className: "_sz-mx-14 _sz-my-6 _sz-p-0 _sz-text-center _sz-text-xl _sz-font-extrabold _sz-text-black", children: I18n.format('modules.mini.me.print.customization') }), _jsx("div", { className: "_sz-flex _sz-items-center _sz-justify-center _sz-gap-4", children: buttonType[type].map(function (item, index) {
                            var _a;
                            return (_jsxs("div", { className: classnames('_sz-relative _sz-flex _sz-flex-1 _sz-cursor-pointer _sz-flex-col _sz-items-center _sz-justify-center _sz-rounded-xl', styles.card, (_a = {},
                                    _a[styles['card-selected']] = index === buttonSelected,
                                    _a)), onClick: function () { return setButtonSelected(index); }, children: [sidePreviewDom(item), _jsxs("div", { className: styles['text-content'], children: [item.price && (_jsx("div", { className: "_sz-text-center _sz-text-sm _sz-font-black !_sz-leading-5 _sz-text-[var(--sunzi-theme-color)]", children: "+".concat(Currency.format(item.price, shop.currency)) })), _jsx("div", { className: "_sz-h-10 _sz-w-full _sz-text-center _sz-text-xs !_sz-leading-5 _sz-text-black ".concat(styles.text, " ").concat(item.price ? '_sz-mt-1' : '_sz-mt-6'), children: item.text })] }), index === buttonSelected && (_jsx(Icon, { className: "_sz-absolute -_sz-top-2 -_sz-right-2", color: "var(--sunzi-theme-color)", size: 32, children: _jsx(SubscriptIcon, {}) }))] }, index));
                        }) }), _jsx("button", { type: "button", className: "_sz-mt-9 _sz-h-13 _sz-w-full _sz-cursor-pointer _sz-rounded-lg _sz-border-none _sz-bg-black _sz-text-base _sz-font-extrabold _sz-text-white", onClick: handleConfirm, children: I18n.format('pass.edit') })] }) }) }));
};
export default IncrementDrawer;
